import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { useQuery } from '@tanstack/react-query';

import { documentsKeys } from './documents-keys';

import type { CheckPartnerSelfieResponse } from '../model';

export const useCheckPartnerSelfie = () => {
  return useQuery({
    queryKey: documentsKeys.checkPartnerSelfie(),
    queryFn: () => {
      return makeRequest<ResponseSuccess<CheckPartnerSelfieResponse>>({
        url: `${config.apiHost}/person-documents/api/v1/merchant-origination/face/client-portrait/check`,
        httpMethod: 'GET',
        credentials: 'include',
      }).then((response) => response.payload);
    },
  });
};
